import React from 'react';
import { useSelectContext } from './SelectContext';

interface SelectValueProps {
  placeholder?: string;
}

export const SelectValue: React.FC<SelectValueProps> = ({ placeholder }) => {
  const { value, optionsMap } = useSelectContext();

  const selectedValue = optionsMap ? optionsMap?.[value] : value;

  return <span className="truncate">{selectedValue || placeholder}</span>;
};
